// extracted by mini-css-extract-plugin
export var activityContainer = "_k9-0";
export var typingIndicatorContainer = "_k9-1";
export var typingIndicatorDot = "_k9-2";
export var wave = "_k9-3";